import { DIRECTORY_TYPES } from 'Webapp/action-types';

export interface DirectoryEntry {
  doc_type: string;
  username: string;
  display_name: string;
  ap_description: string;
  fediverse_handle: string;
  activitypub_id: string;
  avatar_url: string;
  profile_url: string;
  flipboard_uid: number;
  ap_followers_count: number;
  ap_following_count: number;
  statuses_count: number;
  topics: string[];
  topic_names: string[];
  account_type: string;
  is_publisher: boolean;
  is_video: boolean;
  magazine_owner_username: string;
  last_status_at: string;
  date_federated: string;
}

export interface DirectoryFilters {
  query: string;
  docType: string; // 'all' | 'user' | 'magazine'
  sort: string; // 'ap_followers_count' | 'last_status_at' | 'display_name.keyword' | 'date_federated'
  sortOrder: string; // 'desc' | 'asc'
  topic: string;
  lang: string;
  publisherOnly: boolean;
  videoOnly: boolean;
  owner: string;
}

interface DirectoryState {
  entries: DirectoryEntry[];
  loading: boolean;
  error: string | null;
  totalCount: number;
  filters: DirectoryFilters;
  page: number;
}

const initialFilters: DirectoryFilters = {
  query: '',
  docType: 'all',
  sort: 'ap_followers_count',
  sortOrder: 'desc',
  topic: '',
  lang: '',
  publisherOnly: false,
  videoOnly: false,
  owner: '',
};

const initialState: DirectoryState = {
  entries: [],
  loading: false,
  error: null,
  totalCount: 0,
  filters: initialFilters,
  page: 0,
};

export default function directoryReducer(state = initialState, action) {
  switch (action.type) {
    case DIRECTORY_TYPES.DIRECTORY_SEARCH:
      return { ...state, loading: true, error: null, page: 0 };
    case DIRECTORY_TYPES.DIRECTORY_SEARCH_SUCCEEDED:
      return {
        ...state,
        loading: false,
        entries: action.payload.entries,
        totalCount: action.payload.totalCount,
      };
    case DIRECTORY_TYPES.DIRECTORY_SEARCH_FAILED:
      return { ...state, loading: false, error: action.payload };
    case DIRECTORY_TYPES.DIRECTORY_SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case DIRECTORY_TYPES.DIRECTORY_LOAD_MORE:
      return { ...state, loading: true };
    case DIRECTORY_TYPES.DIRECTORY_LOAD_MORE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        entries: [...state.entries, ...action.payload.entries],
        page: state.page + 1,
      };
    case DIRECTORY_TYPES.DIRECTORY_LOAD_MORE_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
